module.exports = __webpack_public_path__ + "static/media/file_type_rar.338d5b5c.svg";